import GenericContent from "./GenericContent";

const ReportContent = ({
  aiAnalysis,
  isRTL,
  language,
  reportApiResponse,
  reportData,
  t,
}) => {
  if (!reportData) {
    return null;
  }

  return (
    <GenericContent
      aiAnalysis={aiAnalysis}
      isRTL={isRTL}
      language={language}
      reportApiResponse={reportApiResponse}
      t={t}
    />
  );
};

export default ReportContent;
